import { render, staticRenderFns } from "./SelectVideoSource.vue?vue&type=template&id=6436289b&scoped=true&"
import script from "./SelectVideoSource.vue?vue&type=script&lang=js&"
export * from "./SelectVideoSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436289b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6436289b')) {
      api.createRecord('6436289b', component.options)
    } else {
      api.reload('6436289b', component.options)
    }
    module.hot.accept("./SelectVideoSource.vue?vue&type=template&id=6436289b&scoped=true&", function () {
      api.rerender('6436289b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/components/cards/form/SelectVideoSource.vue"
export default component.exports